// Tasks and the editable lists — part of the API surface; views import from '../api' (index.js), never from here.
import { get, post, put, del, postForm } from './http';

export const tasksApi = {
  // scope: 'customers' (default) | 'leads' | 'all'; mine applies the ownership filter;
  // status: 'open' (default — the board) | 'done' (the work board's "בוצעו" view).
  board: (mine, scope = 'customers', status = 'open') => {
    const q = new URLSearchParams({ scope });
    if (mine) q.set('mine', '1');
    if (status !== 'open') q.set('status', status);
    return get(`/tasks?${q.toString()}`);
  },
  create: (body) => post('/tasks', body),
  update: (id, body) => put(`/tasks/${id}`, body),
  setStatus: (id, status) => put(`/tasks/${id}/status`, { status }),
  setNote: (id, note) => put(`/tasks/${id}/note`, { note }),
  // Permanent. Takes its tracking list with it (078) and nothing else — no stored file.
  // Manual tasks only — the server refuses an auto-task, which would be recreated by the
  // next board load anyway.
  remove: (id) => del(`/tasks/${id}`),
};

// A task's tracking list (078), keyed by the TASK — one list per task.
export const taskListsApi = {
  // Every task that holds a list, each with its strip. { status: 'open'|'done', mine, job }
  index: ({ status, mine, job } = {}) => {
    const q = new URLSearchParams();
    if (status) q.set('status', status);
    if (mine) q.set('mine', '1');
    if (job) q.set('job', String(job));
    return get(`/task-lists?${q.toString()}`);
  },
  get: (taskId) => get(`/task-lists/${taskId}`),
  create: (taskId, definition) => post(`/task-lists/${taskId}`, definition),
  define: (taskId, definition) => put(`/task-lists/${taskId}/definition`, definition),
  // How the list is organised (079): { group_by: none|state|column, group_column_id?, sort: added|name }.
  setView: (taskId, view) => put(`/task-lists/${taskId}/view`, view),
  remove: (taskId) => del(`/task-lists/${taskId}`),
  // One typed name, or every line of a paste.
  addItems: (taskId, items) => post(`/task-lists/${taskId}/items`, { items }),
  updateItem: (taskId, itemId, patch) => put(`/task-lists/${taskId}/items/${itemId}`, patch),
  setItemsState: (taskId, ids, stateId) => put(`/task-lists/${taskId}/items/state`, { ids, state_id: stateId }),
  removeItem: (taskId, itemId) => del(`/task-lists/${taskId}/items/${itemId}`),
};

export const settingsApi = {
  getAll: () => get('/settings'),
  add: (list, body) => post(`/settings/${list}`, body),
  update: (list, code, body) => put(`/settings/${list}/${code}`, body),
  remove: (list, code) => del(`/settings/${list}/${code}`),
};
